// import React from "react";
// import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import { Wrapper } from "./styled";

const Snils = () => {
  return (
    <Wrapper>
      <Typography>(тут пока ничего не работает)</Typography>
      {/* <Typography>Введите СНИЛС для проверки</Typography>
      <TextField label="Снилс" variant="outlined" /> */}
    </Wrapper>
  );
};

export default Snils;
